export default {
  list: {},
  more: [],
  actionMail: '',
  status: '',
  reminders: 0
};
